"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = exports.didCatch = exports.captureMessage = exports.captureException = void 0;

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

var _config = require("./config");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * 日志错误 初始化
 * @param  {object}  config         配置
 * @config {string}  dsn            Sentry dsn
 * @config {boolean} debug          打开关闭调试模式，默认false
 * @config {string}  release        发布版本
 * @config {string}  environment    设置环境
 * @config {number}  maxBreadcrumbs 捕获最大数
 * @config {function} beforeSend    发送之前修改信息
 * Other API https://docs.sentry.io/error-reporting/configuration/?platform=javascript
 */
var init = function init() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  config = _extends({
    dsn: 'https://f2501efcb894493582a755eb3d6b8716@ets.zhongan.io/10',
    environment: (0, _config.getEnv)(),
    beforeSend: function beforeSend(event, hint) {
      try {
        var REG_LOAD_MESSAGE = /^Loading\s+chunk(.+?)failed/;
        var REG_ISEE_LOAD_MESSAGE = /isee\/.+\/launch\.js/;
        var exceptionType = hint.originalException.title || event.exception.values[0].type;
        var exceptionValue = hint.originalException.message || event.exception.values[0].value;

        if (exceptionType === 'ChunkLoadError' // load js、css 加载失败
        || exceptionValue.match(REG_LOAD_MESSAGE) // 千里眼载入失败
        || exceptionValue.match(REG_ISEE_LOAD_MESSAGE)) {
          event.fingerprint = ['Load Error'];
        }
      } catch (error) {
        console.error(error);
      }

      return event;
    }
  }, config);
  Sentry.init(config);
};
/**
 * 日志错误,react捕获错误，componentDidCatch(error, errorInfo)
 * @param {error}     error
 * @param {errorInfo} errorInfo  错误信息
 */


exports.init = init;

var didCatch = function didCatch(error, errorInfo) {
  Sentry.withScope(function (scope) {
    scope.setExtras(errorInfo);
    Sentry.captureException(error);
  });
};
/**
 * 日志错误,手动捕获错误
 * @param {error} error 错误信息,new Error("Something broke")
 */


exports.didCatch = didCatch;

var captureException = function captureException(error) {
  Sentry.captureException(error);
};
/**
 * 日志错误,手动捕获信息
 * @param {string} message 错误信息
 * @param {string} level   设置级别，默认error。fatal, error, warning, info，debug
 */


exports.captureException = captureException;

var captureMessage = function captureMessage(message) {
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'error';
  Sentry.captureMessage(message, level);
};

exports.captureMessage = captureMessage;